





















































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { Category } from '@/models/Category'
import Select from '@/components/Select.vue'

@Component({
	components: {
		Select,
	},
})
export default class CategoryForm extends Vue {
	@Prop({ default: null }) public editCategory !: Category
	@Prop({ default: () => [] }) public parentValues !: object[]
	@Prop({ default: null }) public singleEdit!: string
	private category: Category = new Category()
	private formElements: object[] = [
		{ name: 'parent', label: 'Parent', placeholder: 'Parent', type: 'select', options: this.parentValues },
		{ name: 'name', label: 'Name*', placeholder: 'Name', type: 'text', required: true },
		{ name: 'description', label: 'Description', placeholder: 'Description', type: 'textarea' },
	]

	@Watch('editCategory')
	private onEditCategoryUpdate() {
		this.category = this.editCategory
	}

	get filteredFormElements() {
		if (this.singleEdit) {
			return this.formElements.filter((element: any) => element.name === this.singleEdit)
		}
		return this.formElements
	}

	private created() {
		if (this.editCategory) {
			this.category = this.editCategory
		}
	}

	private beforeDestroy() {
		this.category.reset()
	}

	private submit() {
		this.$validator.validateAll().then((result) => {
			if (!result) {
				this.$toasted.error('Please fix form errors.')
				return
			}
			this.$emit('submit', this.category)
		})
	}
}
